// extracted by mini-css-extract-plugin
module.exports = {"VideoGrid":"VideoGrid_VideoGrid__mKviX","inverse":"VideoGrid_inverse__3znMw","Title":"VideoGrid_Title__3bCSt","HeroCard":"VideoGrid_HeroCard__1qtQq"};